import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
/**
 * A lock screen for the Anvato player.
 */
const LockScreen = ({
  style,
  message,
  outboundLink,
  actionButton,
}) => (
  <div className="adobe-primetime-lock-screen">
    <div className="adobe-primetime-lock-screen__image" style={style} />

    <div className="adobe-primetime-lock-screen__container">
      <div className="adobe-primetime-lock-screen__controls">
        <div>{parse(DOMPurify.sanitize(message))}</div>
        {actionButton && (
          <button onClick={actionButton.onClick} type="button">
            {actionButton.title}
          </button>
        )}

        {outboundLink && (
          <a
            href={outboundLink.link}
            className="adobe-primetime-lock-screen__outbound-link"
          >
            {outboundLink.title}
          </a>
        )}
      </div>
    </div>
  </div>
);

LockScreen.propTypes = {
  actionButton: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
  }),
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  message: PropTypes.string.isRequired,
  outboundLink: PropTypes.shape({
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};

LockScreen.defaultProps = {
  actionButton: null,
  style: {},
  outboundLink: null,
};

export default LockScreen;
